import { useLingui } from '../../../../../../node_modules/@lingui/react/dist/index.mjs';
import * as React from 'react';
import { CircularProgress } from '../atoms/CircularProgress.mjs';
import Typography from '../atoms/Typography.mjs';
import modules_47ae913e from './Loading.module.css.mjs';

const LoggingInScreen = ()=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    return /*#__PURE__*/ React.createElement(Typography, {
        variant: "header",
        align: "center"
    }, $__i18n._({
        id: "login.loading"
    }));
};
const LoadingScreen = ()=>/*#__PURE__*/ React.createElement("div", {
        className: modules_47ae913e.loadingScreen
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        size: 32
    }));

export { LoadingScreen, LoggingInScreen };
//# sourceMappingURL=Loading.mjs.map
